module.exports = __webpack_public_path__ + "img/0-02-0a-d6a973c9ee0eb8bb89a960bf54e58a6d382d203bc3cf94160715ca0ab33891a0_98c6928a.4ab21fcb.jpg";